import React from "react";
import ReportTable from "../ReportTable";
import { principleTitles, safeText } from "./helpers";
import usePrincipleData from "./usePrincipleData";

const Principle7 = ({ styles }) => {
  const { loading, principle } = usePrincipleData(7);
  const essential = principle?.essentialIndicators || {};
  const leadership = principle?.leadershipIndicator || {};

  const topAffiliations = Array.isArray(essential?.listOf10TradeandIndustry)
    ? essential.listOf10TradeandIndustry
    : [];

  const topAffiliationRows = topAffiliations.map((row, idx) => ({
    _id: row?._id || `p7-e1b-${idx}`,
    serial: idx + 1,
    name: safeText(row?.name, "N/A"),
    reach: safeText(row?.reach, "N/A"),
  }));

  const antiCompetitiveRows = Array.isArray(essential?.antiCompetitiveConduct)
    ? essential.antiCompetitiveConduct
    : [];

  const antiCompetitiveTableRows = antiCompetitiveRows.map((row, idx) => ({
    _id: row?._id || `p7-e2-${idx}`,
    authority: safeText(row?.name, "N/A"),
    briefCase: safeText(row?.briefCase, "N/A"),
    correctiveAction: safeText(row?.correctiveActions, "N/A"),
  }));

  const publicPolicyRows = Array.isArray(leadership?.publicPolicyPositions)
    ? leadership.publicPolicyPositions
    : [];

  const publicPolicyTableRows = publicPolicyRows.map((row, idx) => ({
    _id: row?._id || `p7-l1-${idx}`,
    policy: safeText(row?.policyAdvocated, "N/A"),
    method: safeText(row?.advocacyMethod, "N/A"),
    publicDomain: safeText(row?.informationInPublicDomain, "N/A"),
    reviewFrequency: safeText(row?.reviewFrequencyByBoard, "N/A"),
    webLink: safeText(row?.webLink, "N/A"),
  }));

  return (
    <div className={styles.principleBlock}>
      <div className={styles.principleHeading}>{`PRINCIPLE 7: ${principleTitles[6]}`}</div>
      {loading ? <div className={styles.meta}>Loading principle 7...</div> : null}

      <div className={styles.band}>I. ESSENTIAL INDICATOR</div>

      <div className={styles.question}>
        1. (a) Number of affiliations with trade and industry chambers/associations.
      </div>
      <div className={styles.answer}>{safeText(essential?.numberOfAffiliationsWithTrade, "N/A")}</div>

      <div className={styles.question}>
        1. (b) List the top 10 trade and industry chambers/ associations (determined based on the total members of such body) the entity is a member of / affiliated to.
      </div>
      <ReportTable
        showSerialNumber={false}
        columns={[
          { field: "serial", label: "S. No" },
          { field: "name", label: "Name of the trade and industry chambers / associations" },
          { field: "reach", label: "Reach of trade and industry chambers / associations (State/National)" },
        ]}
        rows={topAffiliationRows}
      />

      <div className={styles.question}>
        2. Provide details of corrective action taken or underway on any issues related to anti- competitive conduct by the entity, based on adverse orders from regulatory authorities.
      </div>
      <ReportTable
        showSerialNumber={true}
        columns={[
          { field: "authority", label: "Name of authority" },
          { field: "briefCase", label: "Brief of the case" },
          { field: "correctiveAction", label: "Corrective action taken" },
        ]}
        rows={antiCompetitiveTableRows}
      />

      <div className={styles.band}>II. LEADERSHIP INDICATOR</div>

      <div className={styles.question}>1. Details of public policy positions advocated by the entity:</div>
      <ReportTable
        showSerialNumber={true}
        columns={[
          { field: "policy", label: "Public policy advocated" },
          { field: "method", label: "Method resorted for such advocacy" },
          { field: "publicDomain", label: "Whether information available in public domain? (Yes / No)" },
          { field: "reviewFrequency", label: "Frequency of Review by Board" },
          { field: "webLink", label: "Web Link, if available" },
        ]}
        rows={publicPolicyTableRows}
      />
      <div className={styles.pageBreak} />
    </div>
  );
};

export default Principle7;
